module.exports = __webpack_public_path__ + "img/BIT_white34.ead30496.jpg";